module.exports = __webpack_public_path__ + "static/img/references5.dfac116.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/references5.jpg
// module id = Ev3N
// module chunks = 1